import { Button, Check, ListBox, SocialAvatar } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useSocialShareModal } from '../SocialShareModalContext';
import { useSocialSharePlatform } from '../SocialSharePlatforms';
import { socialShareModalAccountSelectBlock as block } from '../utils';
import { DEFAULT_ICON_URL } from './constants';
import SocialUserDetails from './SocialUserDetails';

export type AccountsListProps = {
  onSwitchAccount?: () => void;
  onClose?: () => void;
};

const AccountsList: React.FC<AccountsListProps> = ({
  onSwitchAccount: onSwitchAccountProp,
  onClose,
}) => {
  const { selectedAccountId, onSelectAccount } = useSocialShareModal();
  const { platformAlias, accounts, onSwitchAccount } = useSocialSharePlatform();

  const handleSwitchAccount = useCallback(() => {
    onSwitchAccountProp?.();
    onSwitchAccount?.();
  }, [onSwitchAccountProp, onSwitchAccount]);

  return (
    <>
      <ListBox
        density="comfortable"
        selectedKeys={[selectedAccountId]}
        className={block('accounts-list')}
        onSelectionChange={(nextSelection: Set<string>) => {
          onSelectAccount(nextSelection.values().next()?.value);
          onClose();
        }}
      >
        {accounts.map(({ id, avatarSrc, username, handle }) => (
          <ListBox.Item
            key={id}
            icon={
              <SocialAvatar
                src={avatarSrc || DEFAULT_ICON_URL}
                platform={platformAlias}
                className={block('social-user-avatar')}
              />
            }
          >
            <div className={block('social-user-details-menu-item-container')}>
              <SocialUserDetails
                {...{ username, handle }}
                className={block('social-user-details-menu-item')}
              />

              {id === selectedAccountId && <Check />}
            </div>
          </ListBox.Item>
        ))}
      </ListBox>

      <div className={block('switch-account-button-container')}>
        <Button
          fluid
          variant="ghost"
          className={block('switch-account-button')}
          onClick={handleSwitchAccount}
        >
          Switch Account
        </Button>
      </div>
    </>
  );
};

export default AccountsList;
